module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zapoi"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "zapoi__bottom"
  }, [_c('div', {
    staticClass: "zapoi__inner"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb1)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb1, 'hb1')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb2)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb2, 'hb2')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb3)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb3, 'hb3')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb4)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb4, 'hb4')
      }
    }
  }) : _vm._e()])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "carouse__mobile carusieal-abaut"
  }, [_c('v-carousel', {
    staticClass: "carouse"
  }, [_c('v-carousel-item', [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb1)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb1, 'hb1')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-carousel-item', [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb2)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb2, 'hb2')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-carousel-item', [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb3)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb3, 'hb3')
      }
    }
  }) : _vm._e()])], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "block"
  }, [_c('v-col', {
    staticClass: "all-white-block-wrapper",
    attrs: {
      "cols": "3",
      "d-flex": ""
    }
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb5)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb5, 'hb5')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-col', {
    staticClass: "all-white-block-wrapper",
    attrs: {
      "cols": "3",
      "d-flex": ""
    }
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb6)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb6, 'hb6')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-col', {
    staticClass: "all-white-block-wrapper",
    attrs: {
      "cols": "3",
      "d-flex": ""
    }
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb7)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb7, 'hb7')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-col', {
    staticClass: "all-white-block-wrapper",
    attrs: {
      "cols": "3",
      "d-flex": ""
    }
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb8)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb8, 'hb8')
      }
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mobile-offers"
  }, [_c('v-carousel', [_c('v-carousel-item', [_c('v-col', {
    staticClass: "all-white-block-wrapper",
    attrs: {
      "d-flex": ""
    }
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb5)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb5, 'hb5')
      }
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('v-carousel-item', [_c('v-col', {
    staticClass: "all-white-block-wrapper",
    attrs: {
      "d-flex": ""
    }
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb6)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb6, 'hb6')
      }
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('v-carousel-item', [_c('v-col', {
    staticClass: "all-white-block-wrapper",
    attrs: {
      "d-flex": ""
    }
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb7)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb7, 'hb7')
      }
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('v-carousel-item', [_c('v-col', {
    staticClass: "all-white-block-wrapper",
    attrs: {
      "d-flex": ""
    }
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb8)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb8, 'hb8')
      }
    }
  }) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "text_nark"
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb9)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb9, 'hb9')
      }
    }
  }) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zapoi__top"
  }, [_c('h1', {
    staticClass: "zapoi__titler"
  }, [_vm._v("Лечение алкоголизма")]), _vm._v(" "), _c('div', {
    staticClass: "zapoi__desc"
  }, [_vm._v("Помощь алкозависимым")]), _vm._v(" "), _c('button', {
    staticClass: "button-zapoi-item is-mobile-z button-mobile"
  }, [_vm._v("\n                Вызвать нарколога\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a580bc6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Alcogolizm/index.vue
// module id = 128
// module chunks = 2